
import { createContext, useContext, useEffect } from "react";
import tripSocket from "./trip-socket.jsx"

const TripSocketContext = createContext();

export const useTripSocket = () => {
    return useContext(TripSocketContext);
};

export const TripSocketProvider = ({ children }) => {
    useEffect(() => {
        const handleSocketConnected = () => {
            console.log("socket conneced");
        };

        const handleSocketDisconnected = () => {
            console.log("handleSocketDisconnected");
        };

        tripSocket.on("disconnect", handleSocketDisconnected);
        tripSocket.on("connect", handleSocketConnected);

        return () => {
            tripSocket.off("disconnect", handleSocketDisconnected);
            tripSocket.off("connect", handleSocketConnected);
        };
    }, [tripSocket]);

    return (
        <TripSocketContext.Provider value={{ tripSocket }}>
            {children}
        </TripSocketContext.Provider>
    );
};